var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-body-1"},[_vm._v("Rum: "+_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }